import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Hourglass, AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { STATUS } from "@/lib/constants";
import { StatusBadge } from "@/components/StatusBadge";
import { cn } from "@/lib/utils";

export const StuckCandidates = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/ai/stuck").then((r) => setD(r.data)).catch(() => setD({ items: [], total: 0 })); }, []);
  if (!d) return null;
  return (
    <div className="surface p-5 rise" data-testid="stuck-candidates">
      <div className="flex items-center justify-between mb-3"><p className="eyebrow flex items-center gap-1"><Hourglass className="h-3.5 w-3.5" />Siswa Macet di Tahap</p><span className={cn("text-xs font-semibold rounded-full px-2 py-0.5", d.total ? "bg-amber-100 text-amber-800" : "bg-emerald-100 text-emerald-800")} data-testid="stuck-total">{d.total} siswa</span></div>
      {d.items.length === 0 ? <p className="text-sm text-muted-foreground" data-testid="stuck-empty">Tidak ada siswa yang tertahan jauh melebihi rata-rata tahapnya.</p> : (
        <ul className="divide-y divide-border/60 max-h-80 overflow-y-auto" data-testid="stuck-list">
          {d.items.map((c) => (
            <li key={c.id} className="py-2 text-sm" data-testid={`stuck-${c.yutaka_id}`}>
              <div className="flex flex-wrap items-center gap-2"><Link to={`/candidates/${c.id}`} className="font-medium hover:underline">{c.name}</Link><span className="font-mono text-[11px] text-muted-foreground">{c.yutaka_id}</span><StatusBadge status={c.status} className="text-[10px]" /><span className={cn("ml-auto text-xs font-semibold", c.severity === "high" ? "text-red-700" : "text-amber-700")} data-testid={`stuck-days-${c.yutaka_id}`}>{c.days} hari{c.avg_days ? ` (rata² ${c.avg_days})` : ""}</span></div>
              <p className="text-xs text-muted-foreground mt-0.5 flex gap-1"><AlertTriangle className="h-3 w-3 shrink-0 mt-0.5" />{c.action}</p>
            </li>))}
        </ul>
      )}
    </div>
  );
};
